import {
  MESSAGE_CHANNEL,
  MESSAGES_ADD_DIRECTIONS,
} from "../../../packages/constants";
import { chatActions, chatProvider } from "../../chat";
import { authSelectors } from "../../auth";
import type { AppStore } from "../../../store";
import type { GetMessagesResponse } from "../../chat/types";

const { selectUserId } = authSelectors;
const { addMessages } = chatActions;
const { getAuthorListData, getMessagesData } = chatProvider;

export const newMessageHandler = (
  { dispatch, getState }: AppStore,
  msg: GetMessagesResponse["data"]
) => {
  if (msg) {
    const userId = selectUserId(getState());
    const messages = getMessagesData(msg?.messages, MESSAGE_CHANNEL.SSE);
    const authors = getAuthorListData(msg?.authors, userId);

    const messageAuthorId = messages?.[0]?.authorId;
    const actionArguments = { messages, authors };

    const { INSIDE, END } = MESSAGES_ADD_DIRECTIONS;

    if (userId === messageAuthorId) {
      const params = { ...actionArguments, direction: INSIDE };

      dispatch(addMessages(params));
    } else {
      const params = { ...actionArguments, direction: END };

      dispatch(addMessages(params));
    }
  }
};
